import { render } from "./BabylonScene.vue?vue&type=template&id=10c93abd&scoped=true&ts=true"
import script from "./BabylonScene.vue?vue&type=script&lang=ts"
export * from "./BabylonScene.vue?vue&type=script&lang=ts"

import "./BabylonScene.vue?vue&type=style&index=0&id=10c93abd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c93abd"]])

export default __exports__